import type { Moment } from 'moment'
import moment from 'moment-timezone'
import type { CalendarEvent } from 'paintscout'

export function getEstimatorDayEvents({
  events,
  estimatorId,
  date,
  timezone
}: {
  events: CalendarEvent[]
  estimatorId: string
  date: Moment
  timezone?: string
}) {
  const dateMoment = timezone ? moment.tz(date.format('YYYY-MM-DD'), 'YYYY-MM-DD', timezone) : moment(date)

  return events.filter((e) => {
    const eventDayStart = timezone ? moment(e.start).tz(timezone).startOf('day') : moment(e.start).startOf('day')
    const eventDayEnd = timezone ? moment(e.end).tz(timezone).endOf('day') : moment(e.end).endOf('day')

    return (
      e.eventType !== '_unavailable_' &&
      e.estimator?.id === estimatorId &&
      dateMoment.isBetween(eventDayStart, eventDayEnd, null, '[]')
    )
  })
}
